import { Injectable } from '@angular/core';
import { FileInfo, GalaxyImageUploaderService, UploadResponse } from '@vendasta/galaxy/uploader';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService, Environment } from '@galaxy/core';

@Injectable()
export class UploadImageModalService extends GalaxyImageUploaderService {
  constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    super(httpClient);
  }

  public getURL(): string {
    switch (this.environmentService.getEnvironment()) {
      case Environment.DEMO: {
        return 'https://media-demo.apigateway.co/image/upload';
      }
      case Environment.PROD: {
        return 'https://media-prod.apigateway.co/image/upload';
      }
      default: {
        return 'https://media-demo.apigateway.co/image/upload';
      }
    }
  }

  buildRequest(fileInfo: FileInfo): Observable<UploadResponse> {
    const imageToUpload = fileInfo?.data?.croppedImage || fileInfo.file;
    const formData = new FormData();

    formData.append('image', imageToUpload);
    return this.httpClient.post<UploadResponse>(this.getURL(), formData, { withCredentials: true });
  }
}
